module.exports = __webpack_public_path__ + "img/carousel-1.830020d8.jpg";